module.exports = __webpack_public_path__ + "img/logo_digemig.2af6f384.png";